import { Action } from '@ngrx/store';
import { LandlineConsumptionInterface } from '../../models/landline-consumption.interface';

export enum ELandlineConsumptionActions {
  GetLandlineConsumption = '[LANDLINE_CONSUMPTION] Get landline consumption',
  GetLandlineConsumptionSuccess = '[LANDLINE_CONSUMPTION] Get landline consumption success',
  GetLandlineConsumptionFailure = '[LANDLINE_CONSUMPTION] Get landline consumption failure'
}

export class GetLandlineConsumption implements Action {
  public readonly type = ELandlineConsumptionActions.GetLandlineConsumption;
  constructor(public landLine: string) {}
}

export class GetLandlineConsumptionSuccess implements Action {
  public readonly type = ELandlineConsumptionActions.GetLandlineConsumptionSuccess;
  constructor(public payload: LandlineConsumptionInterface) {}
}

export class GetLandlineConsumptionFailure implements Action {
  public readonly type = ELandlineConsumptionActions.GetLandlineConsumptionFailure;
}

export type LandlineConsumptionActions = GetLandlineConsumption | GetLandlineConsumptionSuccess | GetLandlineConsumptionFailure;
